export const getSizeTotal = items =>
	items.reduce((total, item) => total + item.size * item.amount, 0);
